import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchCaseCaseRegistry, getCaseRegistryVariant } from 'app/edozvola/cases/case-case-registry-form/service/case-registry.service';
import { useNavigate } from 'react-router-dom';
import { CaseCaseRegistryModel } from 'app/edozvola/cases/cases.model';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { ERRORS, messages } from 'app/config/constants';
import { saveCaseCaseRegistry } from 'app/edozvola/cases/service/cases.service';

export const getCaseRegistryVariantQuery = (idCase: string, caseInPreview: boolean) => {
  return useQuery({
    queryKey: ['case-registry-variant', { idCase: idCase, caseInPreview: caseInPreview }],
    queryFn: () => getCaseRegistryVariant(idCase, caseInPreview),
  });
};

export const fetchCaseCaseRegistryQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['case-registry-data', { idCase: idCase }],
    queryFn: ({ signal }) => fetchCaseCaseRegistry(idCase),
    enabled: !!idCase,
  });
};

export const saveCaseCaseRegistryMutation = (caseId: string, onSuccess) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (caseRegistry: CaseCaseRegistryModel) => saveCaseCaseRegistry(caseId, caseRegistry),
    onSuccess: data => {
      showToast(toast.success, messages.DATA_SAVED);
      onSuccess(data);
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
      navigate('/cases/');
    },
  });
};
